const BASE_URL = 'https://dev.exdev.ir/v1/'
const SOCKET_URL = 'https://dev.exdev.ir/'

export {
    BASE_URL,
    SOCKET_URL
}

